import styled from 'styled-components';

import Section from 'components/library/layout/Section';

export const StyledSection = styled(Section)`
  .input {
    margin-bottom: 1em !important;
  }
`;
